export default __webpack_public_path__ + "static/media/blog-post-layout-05-img-04.55890679.jpg";